const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/security/reducers/security.reducer.js